import api from './api';

interface IChurchUser {
  name: string;
  cpf: string | number;
  phone: string | number;
  email: string;
  password: string;
  churchId: string | number;
  profileId: undefined | number;
}

interface IEditUser {
  name: string;
  cpf: string;
  phone: string | number;
  password: string;
  email: string;
  churchId: string | number;
  id: number | string;
  profileId: undefined | number;
}

interface IListFrequency {
  limit?: number;
  page?: number;
  church?: string;
  initialDate: string;
  finalDate: string;
  hasComments?: boolean;
  sector: string;
  isOutOfDate?: boolean;
}

interface IFrequency {
  date: Date | string;
  // churchId: string | number;
  leader_id?: number;
  pastor_present: boolean;
  tithes: string;
  offers: string;
  comments: string;
  quarter_number: string;
  lesson_number: string;
  out_of_date_justification?: string;
  is_out_of_date?: boolean;
  classes: {
    id: string;
    attendance: string;
  }[];
}

interface IUpdateClassesPeriod {
  year: number;
  quarter: number;
}

class UserService {
  async createUserBS({
    name,
    cpf,
    password,
    phone,
    email,
    churchId,
    profileId,
  }: IChurchUser): Promise<any> {
    const response = await api.post(`/bs/users`, {
      name,
      cpf,
      password,
      phone,
      email,
      church_id: churchId,
      profile_id: profileId,
    });

    return response.data;
  }

  async editUserBS({
    name,
    password,
    phone,
    email,
    churchId,
    id,
    cpf,
    profileId,
  }: IEditUser): Promise<any> {
    if (password === '******') {
      const response = await api.put(`/bs/users/${id}`, {
        name,
        phone,
        email,
        cpf,
        church_id: churchId,
        profile_id: profileId,
      });
      return response.data;
    }
    const response = await api.put(`/bs/users/${id}`, {
      name,
      password,
      email,
      phone,
      cpf,
      church_id: churchId,
    });

    return response.data;
  }

  async listFrequency({
    page = 1,
    limit,
    church,
    finalDate,
    hasComments,
    initialDate,
    isOutOfDate,
    sector,
  }: IListFrequency): Promise<any> {
    const response = await api.get(`/bs/frequencies`, {
      params: {
        page,
        limit,
        church,
        finalDate,
        hasComments,
        initialDate,
        isOutOfDate,
        sector,
      },
    });

    return response.data;
  }

  async listChurchNotRegistred({
    page = 1,
    limit,
    church,
    finalDate,
    initialDate,
    sector,
  }: IListFrequency): Promise<any> {
    const response = await api.get(`/bs/church/not-registered-frequncies`, {
      params: {
        page,
        limit,
        church,
        finalDate,
        initialDate,
        sector,
      },
    });

    return response.data;
  }

  async deleteFrequency(id: string | number): Promise<any> {
    const response = await api.delete(`/bs/frequencies/${id}`);

    return response.data;
  }

  async CreateFrequency(
    data: IFrequency,
    churchId: string | number,
  ): Promise<any> {
    const response = await api.post(`/bs/frequencies/church/${churchId}`, {
      ...data,
      is_out_of_date: false,
    });

    return response.data;
  }

  async ListUpdateClasseRequest({
    year,
    quarter,
  }: IUpdateClassesPeriod): Promise<any> {
    const response = await api.get(
      `/update-classes-request/year/${year}/quarter/${quarter}`,
    );

    return response.data;
  }

  async GetUpdateClassesPeriod(): Promise<IUpdateClassesPeriod> {
    const response = await api.get(`/update-classes-period`);

    return response.data as IUpdateClassesPeriod;
  }

  async UpdateUpdateClassesPeriod({
    year,
    quarter,
  }: IUpdateClassesPeriod): Promise<IUpdateClassesPeriod> {
    const response = await api.put(`/update-classes-period`, {
      year,
      quarter,
    });

    return response.data as IUpdateClassesPeriod;
  }

  async EditFrequency(
    data: IFrequency,
    id: string | number,
    churchId: string | number,
  ): Promise<any> {
    const response = await api.put(`/bs/frequencies/${id}/church/${churchId}`, {
      ...data,
    });

    return response.data;
  }
}

export default new UserService();
